import Vue from 'vue';
import LoadingComponent from './Loading.vue';
let LoadingConstructor = Vue.extend(LoadingComponent);

let instance;

const Loading = function(options={}){
	instance = new LoadingConstructor({
    	data: options
  	});
  	instance.$mount();
  	document.body.appendChild(instance.$el);
  	return instance;
}


export default Loading;


// WEBPACK FOOTER //
// ./src/components/element/loading/loading.js